import axios from "axios";
import { useCallback, useEffect } from "react";
import useTrait from "../../components/Common/syncUpdateState";
import ResultView from "../../components/WhereToBuy/ResultView";
import Footer from "../../components/_App/Footer";
import Header from "../../components/_App/Header";
import apiClient, { webServiceClient } from "../../data/apiClient";
import cacheClient from "../../data/cacheClient";
import { FOOTER_QUERY } from "../../data/pageQuery";
const url = `/api/whereToBuyStore`;

const WhereToBuy = ({ seo, footer, menu }) => {
  const allStores = useTrait();
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const backCacheData = useCallback(async () => {
    const response = await axios.get(url, {});
    if (response.status === 200) {
      await allStores.set(response.data.allStores);
    } else {
      // console.log(response);
      throw new Error(response.detailsPlaylist);
    }
  }, []);
  useEffect(() => {
    backCacheData();
  }, []);
  return (
    <>
      <Header {...menu} />
      <div className='w-100 d-flex bg-light py-md-4 py-3'>
        <nav style={{}} className='container' aria-label='breadcrumb'>
          <ol className='breadcrumb mb-0'>
            <li className='breadcrumb-item'>
              <a href='#'>Home</a>
            </li>
            <li className='breadcrumb-item d-block d-md-none'>
              <a href='#'>...</a>
            </li>
            <li className='breadcrumb-item'>
              <a href='#'>Distributors</a>
            </li>
            <li className='breadcrumb-item active' aria-current='page'>
              Where To Buy
            </li>
          </ol>
        </nav>
      </div>
      <div className='page-wrapper flex-grow-0'>
        <ResultView
          allStores={allStores?.get()?.length > 0 ? allStores?.get() : []}
        />
      </div>
      <Footer {...footer} />
    </>
  );
};

export async function getStaticProps() {
  const api = webServiceClient();
  const cache = cacheClient();
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";

  const { data } = await(await apiClient()).query({
    query: FOOTER_QUERY,
    variables: {},
    fetchPolicy: "cache-first",
  });

  const {
    queryFooterContents: footerContents,
    queryMenuContents: menuContents,
  } = data;

  const footerContent =
    footerContents[0] != null ? footerContents[0].flatData : [];
  const menuContent = menuContents[0] != null ? menuContents[0].flatData : [];

  return {
    props: {
      footer: footerContent,
      menu: menuContent,
      seo: {
        title:
          "Where to Buy | Air Filters, Oil Filters and Fuel Filters | Automotive Filters",
        metadata:
          "Looking to buy Ryco? We have a wide range of vehicle products and oil, fuel and air filters for sale. Buy with us at Autobarn, Repco and more!",
        keywords: "Buy Ryco, Ryco Filters for Sale",
        socialTitle: "Find your nearest Ryco Distributors",
        url: "/-/where-to-buy",
        isNzOnly: false,
      },
    },
    revalidate: 30 * 60,
  };
}

export default WhereToBuy;
